module.exports = __webpack_public_path__ + "static/media/ic-facebook.767f9e52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-facebook.svg
// module id = 325
// module chunks = 0